import React, {Component} from 'react';
import {Row, Col, Card, Icon, Radio, Checkbox, Button, Modal} from 'antd';
import {app, config} from '../../app';

class IInform extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formData: {
				ti1: '0',
				ti2: '0'
			},
			tongyi: false
		};
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	setData = (data) => app.setStateSync(this, data);

	/**
	 * 修改值
	 * @param name
	 * @param value
	 */
	handleChange = async (name, value) => {
		const {formData} = this.state;
		formData[name] = value;
		await this.setData({formData, tongyi: false});
	};

	/**
	 * 同意变更
	 * @returns {Promise<void>}
	 */
	handleTYChange = async (e) => {
		const checked = e.target.checked;
		if (e.target.checked) {
			const {formData} = this.state;
			console.log(formData);
			if (formData.ti1 !== '0' || formData.ti2 !== '0') {
				Modal.warn({
					title: '被保人健康状况不符合该产品投保要求',
					okText: '确定',
					centered: true
				});
				return;
			}
		}
		await this.setData({tongyi: checked});
	};

	/**
	 * 确定
	 */
	handleConfirm = () => {
		if (this.state.tongyi) {
			this.props.onChange(true);
		} else {
			Modal.warn({
				title: '请阅读并同意投保告知',
				okText: '确定',
				centered: true
			});
		}
	};

	render() {
		let {auth} = this.props, {tongyi} = this.state;
		return (
			<div>
				<Card className="pb-card" size="small" title="投保人声明与授权">
					{
						auth.map((a, i) => {
							return (
								<a href={config.imgUrl + a.url} target="_blank" key={'url-' + i}>
									<Row className="i-link" style={{padding: '4px 0'}}>
										<Col span={20}>{a.name}</Col>
										<Col span={4} style={{textAlign: 'right'}}>
											<Icon type="right" style={{color: '#1890ff'}}/>
										</Col>
									</Row>
								</a>
							);
						})
					}
				</Card>
				<Card className="pb-card" size="small" title="告客户说明">
					<p>若被保险人参加公费医疗、社会医疗保险，对被保险人实际支出的符合当地公费医疗、社会医疗保险支付范围的医疗费用，本产品《国寿综合意外伤害保险（2013版）利益条款》意外伤害医疗保险金免赔额为0元，给付比例为90%；若被保险人未参加公费医疗、社会医疗保险，对被保险人实际支出的符合当地公费医疗、社会医疗保险支付范围的医疗费用，本产品《国寿综合意外伤害保险（2013版）利益条款》意外伤害医疗保险金免赔额为100元，给付比例为80%。</p>
				</Card>
				<Card className="pb-card" size="small" title="被保人健康告知">
					<ul className="bc-tis" style={{listStyleType: 'decimal', paddingLeft: 20}}>
						<li className="ct-li">
							<p
								className="tl-title">被保险人是否患有下列疾患：1）冠状动脉粥样硬化、急慢性心肌梗塞、冠状动脉炎、先天性冠状动脉异常。2）心肌肥厚及心肌病变、继发性或原发性的心肌病、特异性心肌病。3）心瓣膜病：主动脉狭窄和/或关闭不全、二尖瓣脱垂或腱索断裂、感染性心内膜炎、人造瓣膜功能障碍。4）先天性心血管疾病、先天性主动脉瓣狭窄、艾森曼格综合征伴右向左分流。5）心脏传导异常：病态窦房结综合征、Ⅱ度、III
								度房室传导阻滞、预激综合征。6）重症高血压病。7）脑部疾病如重症癫痫病等。8）精神疾病、痴呆综合征、谵妄综合征、精神分裂症、过度嗜眠症等。9）恶性肿瘤、艾滋病或携带艾滋病病毒</p>
							<div className="tl-checks">
								<Radio.Group name="ti1" defaultValue="0" style={{display: 'block'}}
														 onChange={(e) => this.handleChange('ti1', e.target.value)}>
									<Row>
										<Col span={12}><Radio value="1">是</Radio></Col>
										<Col span={12}><Radio value="0">否</Radio></Col>
									</Row>
								</Radio.Group>
							</div>
						</li>
						<li className="ct-li">
							<p className="tl-title">被保险人是否曾患听力、视力、语言、咀嚼、智力障碍，或患有脊柱、胸廓畸形，四肢、手、足、指、趾残缺。</p>
							<div className="tl-checks">
								<Radio.Group name="ti2" defaultValue="0" style={{display: 'block'}}
														 onChange={(e) => this.handleChange('ti2', e.target.value)}>
									<Row>
										<Col span={12}><Radio value="1">是</Radio></Col>
										<Col span={12}><Radio value="0">否</Radio></Col>
									</Row>
								</Radio.Group>
							</div>
						</li>
					</ul>
				</Card>
				<Card className="pb-card" size="small">
					<Checkbox className="no-select" checked={tongyi}
										onChange={this.handleTYChange}>已阅读并同意以上告知</Checkbox>
				</Card>
				<Card className="pb-card" size="small">
					<p>中国人寿保险股份有限公司2019年2季度的综合偿付能力充足率为269.09%，已达到监管的要求。本公司最近一期的风险综合评级，即2019年第1季度的风险综合评级结果为A类公司。 您也可以登录本公司官网<a target="_blank" href="http://www.e-chinalife.com">http://www.e-chinalife.com</a>查询最新的偿付能力相关信息。
					</p>
				</Card>
				<Button type="primary" style={{margin: '20px 0'}} size="large" onClick={() => this.handleConfirm()}
								block>确认</Button>
			</div>
		);
	}
}

export default IInform;



// WEBPACK FOOTER //
// ./src/routes/insure/IInform.jsx